/** Single active config form in the template editor (block / section / sub-section). */
export const TEMPLATE_EDITOR_ACTIVE_FORM_ID = 'template-editor-active-form'
